// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8EDkH","col":"styles_col__37Svc"};